export const ROUTES = {
  user: {
    terms: '/terms',
    privacy: '/privacy',
    passwordReset: '/password-reset'
  },
  auth: {
    login: '/login',
    signup: '/signup',
    sso: '/sso'
  },
  docs: {
    api: '/docs/api',
    apiModule: '/docs/api/:module',
    apiEntity: '/docs/api/:module/:entity'
  },
  ism: {
    drills: '/ism'
  },
  pms: {
    defineComponentLibrary: '/pms/define-component-library',
    components: '/pms/define-component-library/components',
    componentEdit: '/pms/define-component-library/components/:id/edit',
    componentNew: '/pms/define-component-library/components/new',
    spares: '/pms/define-component-library/spares',
    spareNew: '/pms/define-component-library/spares/new',
    spareEdit: '/pms/define-component-library/spares/:id/edit',
    jobs: '/pms/define-component-library/jobs',
    jobNew: '/pms/define-component-library/jobs/new',
    jobEdit: '/pms/define-component-library/jobs/:id/edit',
    vesselComponentLibrary: '/pms/vessel-component-library',
    mainLibraries: '/pms/main-libraries'
  },
  legacy: {
    ism: {
      drills: '/legacy/ism/drills',
      drillTypes: '/legacy/ism/drillTypes'
    },
    voy: {
      comp: '/legacy/comparisons',
      calcDet: '/legacy/comparisons',
      voyages: '/legacy/voy/voyages',
      tracker: '/legacy/tracker',
      tceOverview: '/legacy/tracker/tce-evolution-overview',
      unsyncedClaims: '/legacy/unsynced-claims',
      accTracker: '/legacy/tracker/acc-tracker',
      works: '/legacy/op-works',
      opdash: '/legacy/op-dashboard',
      voyageSearch: '/legacy/voyage-search',
      bunkeringsuppliesreport: '/legacy/bunkering-supplies-report',
      itineraryofvesselreport: '/legacy/itinerary-of-vessel-report',
      cargohistoryandanalysisreport: '/legacy/cargo-history-and-analysis-report',
      cargoreport: '/legacy/cargo-report',
      perfreport: '/legacy/report2',
      pcreport: '/legacy/report',
      reportNoonDetails: '/legacy/noon-details',
      reportVoyageDailyPerformance: '/legacy/voyage-daily-performance',
      reportLatestNoonReports: '/legacy/latest-noon-reports',
      dailyNoonPerformance: '/legacy/daily-noon-performance',
      dailyNoonPerformancePerday: '/legacy/daily-noon-performance-perday',
      stoppageListReport: '/legacy/stoppage-list-report',
      consumptionsPerGradeReport: '/legacy/consumptions-per-grade-report',
      consumptionsPerGradeReportDetailed: '/legacy/consumptions-per-grade-report-detailed',
      weeklyLubricantsReport: '/legacy/weekly-lubricants-report',
      daysAnalysisReport: '/legacy/days-analysis-report',
      cargoStatisticsReport: '/legacy/cargo-statistics-report',
      consCurves: '/legacy/reports/consumption-curves',
      ciiReportVoyages: '/legacy/cii-report-voyages',
      settings: '/legacy/voy-settings',
      portrestrictions: '/legacy/port-restrictions',
      cptypes: '/legacy/voy-cptypes',
      indexValues: '/legacy/index-values',
      porteventtypes: '/legacy/port-event-types',
      bjobs: '/legacy/voyage-batch-jobs',
      tasklists: '/legacy/task-lists',
      tasklistitems: '/legacy/task-list-items',
      tasklistitemcategories: '/legacy/task-list-item-categories'
    },
    fre: {
      freight: '/legacy/freight',
      kpiDashboard: '/legacy/fre/forms/kpi-dashboard',
      overview: '/legacy/freight/overview',
      monitoring: '/legacy/fre/forms/monitoring-host'
    },
    bun: {
      bunkering: '/legacy/bunkering',
      grades: '/legacy/bunkering/stems-host',
      offers: '/legacy/bunkering-offers',
      coqcategories: '/legacy/bunkering/coq-categories',
      coqisostandards: '/legacy/bunkering/coq-iso-standards',
      bunkeringportprices: '/legacy/bunkering/bunkering-port-prices',
      proposedportcalls: '/legacy/bunkering/proposed-port-calls'
    },
    pda: {
      portexpenses: '/legacy/pda/forms/port-expense-dashboard',
      integrationnotifications: '/legacy/pda/forms/integration-notifications-unmatchedinfo-dashboard',
      voyagesintegration: '/legacy/pda/forms/voyages-integration',
      accountingcode: '/legacy/pda/forms/accounting-codes-dashboard',
      expensegroups: '/legacy/pda/forms/port-expense-groups-dashboard',
      expensetypes: '/legacy/pda/forms/port-expense-types-dashboard'
    },
    md: {
      incomecategories: '/legacy/income-categories',
      incomereasons: '/legacy/income-reasons',
      expenseCategories: '/legacy/expense-categories',
      areas: '/legacy/areas',
      countries: '/legacy/countries',
      cities: '/legacy/cities',
      nationalities: '/legacy/nationalities',
      usercompanies: '/legacy/users/user-companies',
      userdepartments: '/legacy/users/user-departments',
      userpositions: '/legacy/users/user-positions',
      userRoles: '/legacy/users/user-roles'
    },
    master: {
      vessels: '/legacy/vessels',
      tanks: '/legacy/vessel-bunkering-tanks',
      vesselspecgroups: '/legacy/vessel-spec-groups',
      vesselclasses: '/legacy/vessel-classes',
      licenseranks: '/legacy/license-ranks',
      dutyranks: '/legacy/dutyranks',
      payrollranks: '/legacy/payroll-ranks',
      vesseltypes: '/legacy/vessel-types',
      companies: '/legacy/companies',
      fueltypes: '/legacy/fuel-types',
      ports: '/legacy/ports',
      cargotypes: '/legacy/cargo-types',
      cargogrades: '/legacy/cargo-grades',
      flags: '/legacy/flags',
      persons: '/legacy/persons',
      ratings: '/legacy/ratings',
      companyRatings: '/legacy/company-ratings',
      customUsers: '/legacy/users/usersCustom',
      departments: '/legacy/users/departments',
      deppos: '/legacy/department-positions',
      roles: '/legacy/users/roles',
      usersettings: '/legacy/user-settings'
    },
    // New admin routes
    admin: {
      menu: '/legacy/md/forms/sitemap',
      health: '/legacy/health-check',
      issues: '/legacy/issue-list',
      dashboard: '/legacy/admin/dashboard',
      workItems: '/legacy/admin/voy.work-items'
    },
    // New notifications routes
    notifications: {
      dashboard: '/legacy/notifications/notifications-dashboard-host'
    },
    // New accounting routes
    acc: {
      freightPayments: '/legacy/fre/forms/payments',
      freightPaymentsList: '/legacy/fre/forms/payments-list',
      bbase: '/legacy/bbase'
    },
    // New workflows routes
    workflows: {
      adminDashboard: '/legacy/admin/dashboard',
      tasks: '/legacy/wf/wf-tasks-host',
      invoices: '/legacy/invoices/invoices',
      wfsets: '/legacy/wf/workflow-sets'
    }
  }
} as const;

export type RouteValue = typeof ROUTES;
